<template>
  <v-content>
    <!-- <v-container 
    fluid>
    <v-layout 
      align-center
      justify-center>
      <v-flex 
        style="max-width: 600px"
        xs12
        md6
        xl4> -->
    <v-layout 
      v-if="createActivity"
      class="py-3"
      style="height: 100%"
      align-center
      fill-height
      justify-center>
      <v-flex 
        d-flex
        style="height: 100%; max-width: 600px;"
        xs12
        md6
        xl4>
        <v-container
          style="height: 100%;"
          fluid
          grid-list-md>
          <v-layout

            row
            fill-height
            justify-center
            align-center
            wrap>
            <v-flex xs12>
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 20 : 12}`"
                 
                  class="roundedcard text-xs-center"
                  style="height: 100%; margin: auto;"

                  color="amber lighten-2"
                  dark
                  @click="choose('moment')">
                  <v-layout
                    align-center
                    justify-space-between
                    row
                    fill-height>
                    <v-card-text class="my-0">
                      <v-icon
                        icon-color="white"
                        height="90"
                        width="90">
                        $vuetify.icons.chartbubble
                      </v-icon>
                      <v-flex
                        xs12>
                        <span
                          class="title font-weight-bold"
                          style="color: #fff">
                          ADD
                        </span>
                      </v-flex>
                      <v-flex 
                        xs12 

                        class="mx-4 headline">
                        <span
                          class="display-1 font-weight-bold"
                          style="color: #fff">
                          MOMENT
                        </span>
                      </v-flex>
                      <v-flex xs12>
                        <span
                          class="font-weight-bold"
                          style="color: #fff">
                          <v-icon
                            left
                            small>fas fa-ellipsis-h</v-icon> Privat <v-icon
                              right
                              small>fas fa-ellipsis-h</v-icon>
                        </span>
                      </v-flex>
                      <v-flex xs12>
                        <span
                          class="font-weight-bold"
                          style="color: #fff">
                          Nur für Freunde sichtbar
                        </span>
                      </v-flex>
                    </v-card-text>
                  </v-layout>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex
              class="my-0 py-0"
              xs12>
              <v-card
                style="height: 40px;"
                flat
                class="text-xs-center"
                color="transparent"
                dark>
                <v-layout
                  class="ma-0 pa-0"
                  align-center
                  justify-center
                  row
                  fill-height>
                  <v-flex>
                    <hr class="dateline">
                  </v-flex>
                  <v-flex 
                    shrink 
                    class="mx-4">
                    <span
                      class="headline"
                      style="color: #90A4AE">
                      ODER
                    </span>
                  </v-flex>
                  <v-flex>
                    <hr class="dateline">
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex
              d-flex

              xs12>
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                 
                  :class="`elevation-${hover ? 20 : 12}`"
                  class="roundedcard text-xs-center"
                  style="height: 100%; margin: auto;"
                  color="pink lighten-1"
                  dark
                  @click="choose('event')">
                  <v-layout
                    align-center
                    justify-space-between
                    row
                    fill-height>
                    <v-card-text class="mt-3 mb-0">
                      <v-icon
                        color="white"
                        size="60">
                        fas fa-star
                      </v-icon>
                      <v-flex class="mt-3">
                        <span
                          class="title font-weight-bold"
                          style="color: #fff">
                          ADD
                        </span>
                      </v-flex>
                      <v-flex 
                        xs12 

                        class="mx-4 headline">
                        <span
                          class="display-1 font-weight-bold"
                          style="color: #fff">
                          EVENT
                        </span>
                      </v-flex>
                      <v-flex xs12>
                        <span
                          class=" font-weight-bold"
                          style="color: #fff">
                          <v-icon
                            left
                            small>fas fa-ellipsis-h</v-icon> Öffentlicht <v-icon
                              right
                              small>fas fa-ellipsis-h</v-icon>
                        </span>
                      </v-flex>
                      <v-flex xs12>
                        <span
                          class=" font-weight-bold"
                          style="color: #fff">
                          Für jeden in deinem Umkreis
                        </span>
                      </v-flex>
                    </v-card-text>
                  </v-layout>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    

    <v-tabs
      v-else-if="!isMobile"
      v-model="model"
      
      :color="model === 'tab-event' ? 'pink lighten-1' : 'amber lighten-2'"
      dark
      fixed-tabs
      icons-and-text>
      <v-tabs-slider 
        :color="model === 'tab-event' ? 'amber lighten-2' : 'pink lighten-1'">
      </v-tabs-slider>


      <v-tab 
        href="#tab-moment">
        Moment
        <v-icon
          icon-color="white"
          height="24"
          width="24">
          $vuetify.icons.chartbubble
        </v-icon>
      </v-tab>
      <v-tab
        href="#tab-event">
        Event
        <!-- <v-icon>fas fa-splotch</v-icon> -->
        <v-icon>fas fa-star</v-icon>
        <!-- <v-icon>fas fa-stars</v-icon> -->
      </v-tab>
         


      
     
     
         
      <v-tabs-items 
        v-model="model"
        touchless
        class="mb-4">
        <v-layout 
          align-center
          justify-center>
          <v-flex 
            style="max-width: 600px"
            xs12
            md6
            xl4>
            <v-tab-item
              origin="center center"
              class="ma-3"
              lazy
              hide-on-leave
              transition="none" 
              reverse-transition="scale-transition" 
              value="tab-moment">
              <app-add-moment></app-add-moment>
            </v-tab-item>


            <v-tab-item
              origin="center center"
              class="ma-3"
              lazy
              hide-on-leave
              transition="scale-transition" 
              reverse-transition="none" 
              value="tab-event">
              <app-add-event></app-add-event>
            </v-tab-item>
          </v-flex>
        </v-layout>
      </v-tabs-items>
    </v-tabs>
    <v-container
      v-else 
      fluid>
      <v-layout 
      
        align-center
        justify-center>
        <v-flex 
          style="max-width: 600px"
          xs12
          md6
          xl4>
          <component
            :is="switchComp"></component>
        </v-flex>
      </v-layout>
    </v-container>
  <!-- </v-flex>
    </v-layout>
    </div>
   
    
  </v-container> -->
  </v-content>
</template>




<script>
import AddEvent     from '@/components/View_Add/AddEvent'
import AddMoment  from '@/components/View_Add/AddMoment'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    'app-add-moment': AddMoment,
    'app-add-event': AddEvent
  },
  data() {
    return {
      model: 'tab-moment',
      switchComp: 'app-add-moment'
      // pickOne: true
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      createActivity: state => state.navigation.responsive.createActivity
    }),
  },
  beforeRouteLeave (to, from, next) {
    this.setCreateActivity(true)
    next()
  },
  methods: {
    ...mapMutations([
      'setCreateActivity'
    ]),

    choose(val) {
      console.log(val)
      if (val === 'event') {
        this.model = 'tab-event'
        this.switchComp = 'app-add-event'
        this.setCreateActivity(false)
        // this.pickOne = false
      } else {
        this.model = 'tab-moment'
        this.switchComp = 'app-add-moment'
        this.setCreateActivity(false)


        // this.pickOne = false
      }
      setTimeout(() => {
        this.$vuetify.goTo(0, {
          duration: 100,
          offset: 0,
          easing: 'easeInOutQuint'
        })
      }, 33)
    }
  }
}
</script>


<style scoped>
.dateline {
  border: 1px solid #CFD8DC;
}

.cardline {
  border: 1px solid #fff;
  max-width: 40px;
}
</style>
